import type { Theme } from '@mui/material';

export const styles = {
  definitionline: (canDrop: boolean, isOver: boolean) => (theme: Theme) => {
    const result = {
      fontSize: 13,
      color: theme.colors.white,
      textAlign: 'center',
      fontWeight: 'bold',
      flexWrap: 'wrap',
      alignItems: 'stretch',
    };
    if (canDrop) {
      if (isOver) {
        Object.assign(result, { backgroundColor: theme.colors.green[400] });
      } else {
        Object.assign(result, { backgroundColor: theme.colors.neutral[400] });
      }
    } else {
      Object.assign(result, { backgroundColor: theme.colors.neutral[300] });
    }
    return result;
  },

  hint: {
    fontSize: 13,
    fontWeight: 600,
  },
};
